"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TESTS", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.TESTS;
  }
});
Object.defineProperty(exports, "customerGroupnameToCustomerName", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.customerGroupnameToCustomerName;
  }
});
Object.defineProperty(exports, "customerNameToCustomerGroupname", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.customerNameToCustomerGroupname;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings["default"];
  }
});
Object.defineProperty(exports, "getProjectManagerGroupnames", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.getProjectManagerGroupnames;
  }
});
Object.defineProperty(exports, "getSupervisorGroupnames", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.getSupervisorGroupnames;
  }
});
Object.defineProperty(exports, "getTechnicianGroupnames", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.getTechnicianGroupnames;
  }
});
Object.defineProperty(exports, "isCustomerGroupname", {
  enumerable: true,
  get: function get() {
    return _CustomGroupnameMappings.isCustomerGroupname;
  }
});

var _CustomGroupnameMappings = _interopRequireWildcard(require("./CustomGroupnameMappings"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}